import UtilsData from "@/utilities/UtilsData";

export default class UtilsTableDataBuilder {
  constructor(rawArrayOfObjects = [], columnFormatters = []) {
    this.rawArrayOfObjects    = rawArrayOfObjects;
    this.columnFormatters     = columnFormatters;
    this.data                 = [];
    this.robustArrayOfObjects = [];
    this.headers              = [];
    this.rows                 = [];
    this.rowsEmptyDataFixer   = [];
    this.buildRobustDataSet();
    return this;
  }

  buildRobustDataSet() {
    this.buildData();
    this.buildHeaders();
    this.buildRows();
  }

  buildData() {
    this.data = this.rawArrayOfObjects.map((o) => {return UtilsData.tryToObject(o, this.columnFormatters)});
    return this.data;
  }

  reducer(accumulator, o) {
    let keys = Object.keys(o);
    for (const k of keys) {
      accumulator[k] = null;
    }
    return accumulator;
  }

  buildHeaders() {
    let headers  = {};
    headers      = this.data.reduce(this.reducer, headers)
    headers      = Object.keys(headers);
    this.headers = headers;
    return this.headers;
  }

  buildRows() {
    this.robustArrayOfObjects = this.data.map((o, i) => {
      const res = {};
      const row = [];
      for (const h of this.headers) {
        if (o.hasOwnProperty(h)) {
          res[h] = o[h];
          row.push(o[h])
        } else {
          res[h] = null;
          row.push(null)
        }
      }
      this.rowsEmptyDataFixer = Array.from(Array(row.length));
      this.rows.push(row);
      return res;
    });
    return this.robustArrayOfObjects;
  }
}
